import React from 'react';
import SarasTrans from "../../../../library/notifications/SarasTrans"
import FormButton from "../../../../library/form/components/FormActionButton2"
import FormLauncher from "../../../cmn/docAutomation/FormLauncher";
import FormWrapper from '../../../../library/form/components/FormWrapper';

const ListChoicesRow = (props) => {
    const { formObject, rowKey, viewData } = props;

    // console.log("debug", viewData);

    return (
        <div style={{minHeight:"100px"}} className="uiBoxBlue uiBoxSection uiContentCenter uiBorderRoundAll uiBoxSection150">
            <div className="contact-details">
                <div className="uiSpacer5">
                    <FormLauncher viewMap={formObject.viewMap} formObject={formObject} 
                            pushFormObject={1}
                            viewData={viewData} rowKey={rowKey} ></FormLauncher>     
                </div>
                <FormWrapper customWrapper="div" formObject={formObject} headerKey="viewConfig" action={{ paramName: "manualOpsButtons" }} >
                    {/* <div className="uiSpacer5"> */}
                    <FormButton formObject={formObject} rowKey={rowKey}
                    action={{ actionId: "edit", paramName:"addAction", actionParam: {}}}  
                    className="uiActionButton" text={<SarasTrans value="Add" />} ></FormButton>

                    <FormButton formObject={formObject} rowKey={rowKey}
                    action={{ actionId: "del", paramName:"delAction", actionParam: {} }}
                    className="uiActionButton" text={<SarasTrans value="Remove" />} ></FormButton>
                </FormWrapper>
            </div>
        </div>
    )
}

export default ListChoicesRow